import { createStateContext } from '@change-corgi/core/react/context';

import type { InitialStateParams } from './initialState';
import { initialState } from './initialState';
import { mutations } from './mutations';
import type { PromotePageState } from './types';

export const {
	StateContext: PromotePageStateContext,
	StateProvider: PromotePageStateContextProvider,
	useStateContext: usePromotePageState,
} = createStateContext<PromotePageState, typeof mutations, InitialStateParams>({
	name: 'PromotePageStateContext',
	mutations,
	initialState: ({ email, name, firstName, lastName, isPublic, isSecureGuest, prefilledWithGuestData }) =>
		initialState({
			email,
			name,
			firstName,
			lastName,
			isPublic,
			isSecureGuest,
			prefilledWithGuestData,
		}),
});
